module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fXX9K"))).then(() => parcelRequire('d0iPb'));